const sky = {
  sky1: "hsl(193, 100%, 98.8%)",
  sky2: "hsl(193, 100%, 97.3%)",
  sky3: "hsl(193, 99.0%, 94.7%)",
  sky4: "hsl(193, 91.4%, 91.4%)",
  sky5: "hsl(194, 82.0%, 86.6%)",
  sky6: "hsl(194, 74.1%, 79.5%)",
  sky7: "hsl(194, 72.3%, 69.6%)",
  sky8: "hsl(193, 77.9%, 53.9%)",
  sky9: "hsl(193, 98.0%, 70.0%)",
  sky10: "hsl(193, 87.0%, 66.5%)",
  sky11: "hsl(195, 100%, 31.5%)",
  sky12: "hsl(195, 100%, 13.0%)"
};
export { sky };
//# sourceMappingURL=sky.mjs.map
